import * as keyapis_identity_b2b_v1_authorization_pb from "./v1/keyapis_identity_b2b_authorization_v1.pb";
import * as keyapis_identity_b2b_v1_system_pb from "./v1/keyapis_identity_b2b_system_v1.pb";

export default {
  v1: {
    resources: {
      authorization: keyapis_identity_b2b_v1_authorization_pb,
      system: keyapis_identity_b2b_v1_system_pb,
    },
  },
};
